import { connect } from 'react-redux'

import Alerts from './Alerts'
import { getAlert, getAlertValues, getStatus } from '../../store/login/reducers'

const mapStateToProps = (state, props) => {
    return {
        alert: getAlert(state),
        status: getStatus(state),
        values: {...props.values, ...getAlertValues(state)}
    }
}

const AlertsContainer = connect(mapStateToProps, null)(Alerts)

export default AlertsContainer
